import {ADD_SAMPLE_PACK} from 'constants/action-types.js';
import {REMOVE_SAMPLE_PACK} from 'constants/action-types.js';

const paletteReducer = (state = {}, action) => {
    let newState;
    switch (action.type) {
    case ADD_SAMPLE_PACK:
        newState = Object.assign({}, state);
        newState[action.payload.id] = action.payload;
        return newState;
    case REMOVE_SAMPLE_PACK:
        newState = Object.assign({}, state);
        delete newState[action.payload.id];
        return newState;
    default:
        return state;
    }
};

export default paletteReducer;
